"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CohortCasaRuleTransformer = void 0;
const _ = require("lodash");
const casa_rules_v2_1 = require("../casa-rules-v2");
const condition_creator_1 = require("../casa-rules-v2/condition-creator");
const optimized_cohort_rule_1 = require("./optimized-cohort-rule");
class CohortCasaRuleTransformer {
    constructor(_cohortRules, _batchRuleSource) {
        this._cohortRules = _cohortRules;
        this._batchRuleSource = _batchRuleSource;
        this._pathConditionMap = new Map();
        this._rule = new casa_rules_v2_1.Rule();
        this._casaBaseConditions = [];
        this.initialPathConditionMap();
        this.optimiseCohortRule(this._cohortRules);
        this._rule.isBatch = true;
    }
    initialPathConditionMap() {
        this._pathConditionMap.set('root', this._rule.joinCondition);
    }
    optimiseCohortRule(cohortRules) {
        for (const cohortRule of cohortRules.cohortRules) {
            for (const fieldName in cohortRule) {
                const subRule = optimized_cohort_rule_1.OPTIMIZED_COHORT_RULES[fieldName];
                if (subRule) {
                    cohortRule[fieldName] = subRule;
                }
            }
        }
    }
    getCasaRule() {
        for (const cohortRule of this._cohortRules.cohortRules) {
            this._pathConditionMap.set('root', new casa_rules_v2_1.JoinCondition());
            for (const fieldName in cohortRule) {
                for (const operation of cohortRule[fieldName]) {
                    let fieldPath = this.getBatchRuleSourceFieldPath(operation.entity, fieldName);
                    fieldPath = ['root', ...fieldPath];
                    for (let index = 1; index < fieldPath.length; index++) {
                        const currentFieldPath = fieldPath.slice(1, index + 1);
                        const parentFieldName = fieldPath[index - 1];
                        this.createConditionAndUpdateTree(currentFieldPath, parentFieldName, operation);
                    }
                    // when adding the last condition - update the listcondition type for corresponding parent
                    this.udpateListCountTypeCondition(operation);
                }
            }
            const userNode = this._pathConditionMap.get('entities.user');
            console.log(userNode);
            if (userNode.condition.conditions.length > 0) {
                this._casaBaseConditions.push(this._pathConditionMap.get('entities.user'));
            }
            this._pathConditionMap.clear();
        }
        this._casaBaseConditions.forEach((joinCondition) => {
            this._rule.joinCondition.addCondition(joinCondition);
        });
        return this._rule;
    }
    getBatchRuleSourceFieldPath(fieldType, fieldName) {
        return [
            'entities.user',
            ...this.getBatchRulePropertyFromFieldType(fieldType),
            fieldName,
        ];
    }
    getBatchRuleSourceFieldPathForEntity(fieldType) {
        return [
            'entities.user',
            ...this.getBatchRulePropertyFromFieldType(fieldType),
        ];
    }
    getBatchRulePropertyFromFieldType(fieldType) {
        const fieldTypeMap = {
            bill: ['bills'],
            product: ['bills', 'products'],
            productInfo: ['bills', 'products', 'productInfo'],
            computed: ['computed'],
            computedBusinessUnit: ['computedBusinessUnit'],
            storeTags: ['bills', 'storeTags'],
            storeInfo: ['bills', 'storeInfo'],
            tier: ['loyalty', 'businessUnit'],
            user: [''],
        };
        return fieldTypeMap[fieldType] || [''];
    }
    createConditionAndUpdateTree(currentFielPath, parentFieldName, operation) {
        const currentFieldName = _.last(currentFielPath);
        const parentCondition = this._pathConditionMap.get(parentFieldName);
        if (!this._pathConditionMap.has(currentFieldName)) {
            const currentCondition = this.createCondition(currentFielPath, operation);
            if (currentCondition) {
                this.appendChildToParent(parentCondition, currentCondition);
            }
        }
    }
    createCondition(fieldPath, operation) {
        const fieldName = _.last(fieldPath);
        const fieldType = this.getTypeFromBatchRuleSource(fieldPath);
        if (!fieldType) {
            return null;
        }
        const newCondition = this.createNewCondition(fieldName, operation, fieldType);
        if (!newCondition) {
            return null;
        }
        const wrapperCondition = this.wrapChildConditionWithSectionCondition(newCondition, fieldType, fieldName);
        if (_.includes(['list', 'object'], fieldType)) {
            this._pathConditionMap.set(fieldName, newCondition);
        }
        return wrapperCondition;
    }
    createNewCondition(fieldName, operation, fieldType) {
        let newCondition;
        switch (fieldType) {
            case 'list':
                newCondition = (0, condition_creator_1.createNewListCondition)(fieldName);
                break;
            case 'object':
                newCondition = (0, condition_creator_1.createNewSectionCondition)(fieldName);
                break;
            case 'number':
            case 'string':
            case 'date':
                newCondition = (0, condition_creator_1.createNewFieldCondition)(fieldName, getOperatorFromCohortOperation(operation, fieldType), operation.value, operation.negate);
                break;
            default:
                newCondition = null;
                break;
        }
        return newCondition;
    }
    getTypeFromBatchRuleSource(fieldPath) {
        const formatedFieldPath = fieldPath.join('/properties/').split('/');
        const fieldInfo = _.get(this._batchRuleSource.properties, formatedFieldPath);
        if (!fieldInfo) {
            return null;
        }
        return fieldInfo.type;
    }
    appendChildToParent(parentCondition, childCondition) {
        if (parentCondition instanceof casa_rules_v2_1.ListCondition) {
            parentCondition.condition.addCondition(childCondition);
        }
        else if (parentCondition instanceof casa_rules_v2_1.SectionCondition) {
            parentCondition.condition.addCondition(childCondition);
            if (childCondition instanceof casa_rules_v2_1.SectionCondition &&
                childCondition.condition.conditions[0] instanceof casa_rules_v2_1.FieldCondition &&
                parentCondition.listAccessor &&
                parentCondition.listAccessor !== 'entities.user')
                this._pathConditionMap.delete(parentCondition.listAccessor);
        }
        else if (parentCondition instanceof casa_rules_v2_1.JoinCondition) {
            parentCondition.addCondition(childCondition);
        }
    }
    wrapChildConditionWithSectionCondition(condition, fieldType, fieldName) {
        if (fieldType === 'object') {
            return condition;
        }
        const wrapperCondition = (0, condition_creator_1.createNewSectionCondition)(fieldName);
        wrapperCondition.condition.addCondition(condition);
        return wrapperCondition;
    }
    udpateListCountTypeCondition(operation) {
        const listCountTypeCondition = operation.listConditionType
            ? {
                type: operation.listConditionType.type,
                value: operation.listConditionType.value,
            }
            : null;
        if (!listCountTypeCondition) {
            return;
        }
        const fieldPath = this.getBatchRuleSourceFieldPathForEntity(operation.entity);
        const fieldToApplyListCondition = _.last(fieldPath);
        const fieldType = this.getTypeFromBatchRuleSource(fieldPath);
        if (!fieldType || !(fieldType === 'list')) {
            return;
        }
        const conditionToApply = this._pathConditionMap.get(fieldToApplyListCondition);
        (0, condition_creator_1.updateListCountTypeInListCondition)(conditionToApply, listCountTypeCondition);
    }
}
exports.CohortCasaRuleTransformer = CohortCasaRuleTransformer;
function getOperatorFromCohortOperation(operation, fieldType) {
    return casa_rules_v2_1.Operator.getOp(fieldType, operation.operation);
}



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/cohort-rule/cohort-rule-casa-rule-transformer.js
// module id = 1251
// module chunks = 0